import { createApi } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../app/reducerPaths";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";

export const rejectedCarsApi = createApi({
  reducerPath: reducerPaths.rejectedCarsApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getRejectedCars: builder.query({
      query: ({ params = {} }) => {
        return {
          url: `/myGarage/Seller/rejected`,
          method: "GET",
          params
        }
      }
    })
  }),
});

export const {
  useLazyGetRejectedCarsQuery
} = rejectedCarsApi;
